module.exports = __webpack_public_path__ + "img/checkin.6012a504.svg";